import { Link } from '@ipfabric/ui-components/Link/Link';
import type { Filters } from '@ipfabric/utils/table/filters/filters';
import type { TableCellContentRenderFunction } from 'components/Table/model/TableCellContentRenderFunction';
import type { ReactNode } from 'react';

type RoutingPolicyMatch = {
  original: string;
  type: string;
  valueList: string[];
};

const renderMatchItem = (
  match: RoutingPolicyMatch,
  rowData: any,
): ReactNode => {
  const filers: Filters[] = [{ sn: ['eq', rowData.sn] }];

  switch (match.type) {
    case 'ip acl':
    case 'ipv6 acl':
      if (match.valueList.length) {
        filers.push({
          or: match.valueList.map((value) => ({
            policyName: ['eq', value],
          })),
        });
      }
      return (
        <Link
          to={`/technology/security/access-list?options=${encodeURIComponent(
            JSON.stringify({
              filters: {
                and: filers,
              },
            }),
          )}&tmp=1`}
        >
          {match.original}
        </Link>
      );
    case 'ip prefix-list':
    case 'ipv6 prefix-list':
      if (match.valueList.length) {
        filers.push({
          or: match.valueList.map((value) => ({ name: ['eq', value] })),
        });
      }

      return (
        <Link
          to={`${
            match.type === 'ip prefix-list'
              ? '/technology/routing/prefix-lists/ipv4'
              : '/technology/routing/prefix-lists/ipv6'
          }?options=${encodeURIComponent(
            JSON.stringify({
              filters: {
                and: filers,
              },
            }),
          )}&tmp=1`}
        >
          {match.original}
        </Link>
      );
    default:
      return match.original;
  }
};

export const renderRoutingMatchList: TableCellContentRenderFunction<any> = ({
  row,
  context,
  index,
  severity,
}) => {
  const matchList = row.matchList as RoutingPolicyMatch[];
  return {
    content: context.detailView ? (
      matchList.map((value, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no better key
        <span className='pb-1.5' key={i}>
          {renderMatchItem(value, row)}
          {i < matchList.length - 1 && <br />}
        </span>
      ))
    ) : (
      <>
        {matchList[0] && renderMatchItem(matchList[0], row)}
        {matchList.length > 1 && (
          <>
            {' '}
            <Link
              renderAs='button'
              accent={severity === null ? 'positive' : 'contrast'}
              onClick={() => {
                context.onShowDetailClick?.(index);
              }}
            >
              (+
              {matchList.length - 1})
            </Link>
          </>
        )}
      </>
    ),
  };
};
